import { ColorSelectorButton } from 'core-components/library/common'
import { BorderTypeSelector } from 'core-components/sitebuilder/settings/detail/basicSettings/borderSelector/BorderTypeSelector'
import { SizeSelector } from 'core-components/sitebuilder/settings/detail/basicSettings/SizeSelector'

interface IBorderSelector {
  value: string
  onChange: (newValue: string) => void
  editorClassName: string
}

export const BorderSelector = ({ value = '', onChange, editorClassName }: IBorderSelector) => {
  const [size = '0px', type = 'solid', color = ''] = value.split(' ')

  return (
    <>
      <SizeSelector
        value={`${parseInt(size, 10)}`}
        onChange={(newSize) => {
          onChange(`${newSize || '0'}px ${type} ${color}`)
        }}
        label={'borders'}
      />
      <BorderTypeSelector
        value={type}
        onChange={(newType) => {
          onChange(`${size} ${newType} ${color}`)
        }}
      />
      <ColorSelectorButton
        className={editorClassName}
        buttonText={'border color'}
        color={color}
        onChange={(newColor) => {
          onChange(`${size} ${type} ${newColor}`)
        }}
      />
    </>
  )
}
